import type { FeaturePalette } from "@/shared/components/command-palette/types";

export const appUsagePalette: FeaturePalette = {};
